import { useEffect, useRef } from 'react';

import useStore from '@/state';
import addRefAction from '@/state/selectors/ref/add-ref';
import rmRefByKeyAction from '@/state/selectors/ref/rm-ref-by-key';

const useRefTracking = <T>(key: string, group: string): React.RefObject<T> => {
	const ref = useRef<T>(null);

	const addRef = useStore(addRefAction);
	const rmRefByKey = useStore(rmRefByKeyAction);

	useEffect(() => {
		addRef(key, ref, group);

		return () => {
			rmRefByKey(key);
		};
	}, [addRef, group, key, rmRefByKey]);

	return ref;
};

export default useRefTracking;
